import { useState } from 'react';

import { ErrorBox, ROLE_LABEL, Spinner, formatDateTime, useAsync } from '@solar/ui';

import { api } from '../api';

/**
 * 계정 관리 > 권한 변경 이력 — 레거시 WebService/auth/user/role_history.blade.php 파리티.
 *
 * 레거시는 필터도 페이징도 없이 전체를 한 번에 내렸다. 신규는 페이징만 붙인다.
 * 서버는 권한이 실제로 바뀐 경우만 기록하므로 '변경 전 권한' 이 비는 행은
 * 레거시 이관 데이터에서만 나온다 (레거시 UserAdd 는 저장할 때마다 pre_role NULL
 * 행을 남겼다).
 */

const SIZE = 30;

function roleName(role: number | null): string {
  if (role === null) return '-';
  return ROLE_LABEL[role] ?? String(role);
}

export function RoleHistory() {
  const [page, setPage] = useState(1);
  const list = useAsync(() => api.listRoleHistory({ page, size: SIZE }), [page]);

  const total = list.data?.total ?? 0;
  const lastPage = Math.max(1, Math.ceil(total / SIZE));

  return (
    <div className="admin__body">
      <section className="admin__list">
        {list.loading && <Spinner />}
        {list.error && <ErrorBox message={list.error} onRetry={list.reload} />}

        {list.data && (
          <table className="grid">
            <thead>
              <tr>
                <th>No</th>
                <th>이름</th>
                <th>아이디</th>
                <th>변경 전 권한</th>
                <th>변경 후 권한</th>
                <th>변경자 이름</th>
                <th>변경자 아이디</th>
                <th>변경일</th>
              </tr>
            </thead>
            <tbody>
              {list.data.items.length === 0 && (
                <tr>
                  <td colSpan={8} className="muted">
                    권한 변경 이력이 없습니다.
                  </td>
                </tr>
              )}
              {list.data.items.map((h) => (
                <tr key={h.id}>
                  <td>{h.id}</td>
                  <td>{h.name ?? '-'}</td>
                  <td>{h.user_id ?? '-'}</td>
                  <td>{roleName(h.pre_role)}</td>
                  <td>{roleName(h.be_role)}</td>
                  <td>{h.changer_name ?? '-'}</td>
                  <td>{h.changer_user_id ?? '-'}</td>
                  <td>{formatDateTime(h.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div className="pager">
          <button type="button" onClick={() => setPage((p) => p - 1)} disabled={page <= 1}>
            이전
          </button>
          <span>
            {page} / {lastPage} (총 {total}건)
          </span>
          <button type="button" onClick={() => setPage((p) => p + 1)} disabled={page >= lastPage}>
            다음
          </button>
        </div>
      </section>
    </div>
  );
}
